import SettingArrowIcon from './SettingArrow'

export default {
    SettingArrowIcon
}
